import * as Sentry from '@sentry/react';
import { config } from '../../config';

export function initializeSentry() {
  if (!config.sentryDsn) {
    console.warn('Sentry DSN not configured');
    return;
  }

  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.appEnv,
    release: `${config.version}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: config.appEnv === 'production' ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.01, // 10% of sessions
    replaysOnErrorSampleRate: 0.01, // 100% of sessions with errors
    sampleRate: 0.3,
    // Additional options
    beforeSend(event, hint) {
      // Filter out errors from browser extensions
      if (event.exception) {
        const error = hint.originalException;
        if (error && typeof error === 'object' && 'message' in error) {
          const message = String(error.message);
          if (
            message.includes('chrome-extension://') ||
            message.includes('moz-extension://') ||
            message.includes('safari-extension://')
          ) {
            return null;
          }
        }
      }
      return event;
    },
  });
}

export { Sentry };
